import { FormConfig, FormField } from '../types';

export const paymentDetailsFormConfig: FormConfig = {
  fields: [
    FormField.paymentMethodId,
    FormField.paymentMethodHolderName,
    FormField.addressLine1,
    FormField.addressLine2,
    FormField.city,
    FormField.vat,
    FormField.postalCode,
    FormField.country,
    FormField.notVatRegistered,
    FormField.state
  ],
  required: [
    FormField.paymentMethodId,
    FormField.paymentMethodHolderName,
    FormField.addressLine1,
    FormField.city,
    FormField.postalCode,
    FormField.country
  ],
  disabled: []
};
